import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class DocumentationTypeDto extends BaseEntityDto {
  name: string;
}
